class ProductCards extends HTMLElement {
  constructor() {
    super()
    this.onChangeBound = this.onChange.bind(this)
    this.onHemUpdateBound = this.updateHemNotes.bind(this)
  }

  connectedCallback() {
    this.addEventListener('change', this.onChangeBound)
    this.initSwiper()
    this.initFlashDealClaimedProducts()
    this.initCompareButton()
    document.addEventListener('product-style-updated', this.onHemUpdateBound)
    document.addEventListener('product-info-updated', this.onHemUpdateBound)
  }

  initCompareButton() {
    if (window.location.pathname !== '/') return this.removeCompareButton()

    var btn = this.querySelector('.js-ppc-compare-btn')
    if (!btn) return
    if (btn.classList.contains('ppc-compare-available')) {
      btn.style.display = 'inline'
      var divider = this.querySelector('.js-ppc-compare-divider')
      if (divider) divider.style.display = 'inline'
    }
  }

  removeCompareButton() {
    var btn = this.querySelector('.js-ppc-compare-btn')
    if (btn) btn.remove()
    var divider = this.querySelector('.js-ppc-compare-divider')
    if (divider) divider.remove()
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChangeBound)
    document.removeEventListener('product-style-updated', this.onHemUpdateBound)
    document.removeEventListener('product-info-updated', this.onHemUpdateBound)
  }

  // Current family's hem, derived client-side after PDP updates: prefer the
  // checked hem toggle in the your-cut box (swapped wholesale on every family
  // change), fall back to the checked card's data-hem.
  getCurrentPdpHem() {
    var checked = document.querySelector(
      '.js-your-cut-selector .liquid-pdp__family-toggle-switch input:checked',
    )
    var label = checked?.closest('label')?.querySelector('span')?.textContent.trim().toLowerCase()
    if (label === 'curved' || label === 'straight') return label

    var activeCard = this.querySelector('.pdp-product-cards__item:has(input:checked)[data-hem]')
    if (activeCard) return activeCard.dataset.hem
    return null
  }

  updateHemNotes() {
    var hem = this.getCurrentPdpHem()
    if (!hem) return
    this.setAttribute('data-current-hem', hem)
  }

  getResolvedProductUrl(input) {
    if (!input) return null

    const menuWithPdp = this.closest('menu-with-pdp')
    const isClearanceMode = menuWithPdp?.classList.contains('menu-with-pdp--show-clearance')

    if (isClearanceMode && input.dataset.clearanceProductUrl) {
      return input.dataset.clearanceProductUrl
    }

    return input.value
  }

  syncProductInfoClearanceState() {
    const menuWithPdp = this.closest('menu-with-pdp')
    const productInfo = document.querySelector('product-info')
    if (!menuWithPdp || !productInfo) return

    const isClearanceMode = menuWithPdp.classList.contains('menu-with-pdp--show-clearance')
    productInfo.dataset.showOnlyClearance = isClearanceMode ? 'true' : 'false'
  }

  initSwiper() {
    const swiperElement = this.querySelector('.swiper')
    const swiperNextButton = this.querySelector('.js-swiper-button-next')
    const swiperPrevButton = this.querySelector('.js-swiper-button-prev')
    if (!swiperElement) return
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      loop: false,
      // forceToAxis keeps vertical page scrolling intact; releaseOnEdges hands
      // the wheel back once the row hits either end.
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        releaseOnEdges: true,
      },
      navigation:
        swiperNextButton && swiperPrevButton
          ? {
              nextEl: swiperNextButton,
              prevEl: swiperPrevButton,
            }
          : null,
      on: {
        afterInit: () => {
          setTimeout(() => {
            if (swiperPrevButton) {
              swiperPrevButton.classList.remove('loading')
            }
            if (swiperNextButton) {
              swiperNextButton.classList.remove('loading')
            }
          }, 100)
        },
      },
    })
    window.enablePdpDesktopSwiperMousewheel(swiper)
  }

  initFlashDealClaimedProducts() {
    const productCards = this.querySelectorAll('.pdp-product-cards__item[data-product-handle]')

    if (!productCards.length) return

    productCards.forEach((productCard, index) => {
      const claimedProduct = productCard.querySelector('.js-claimed-product')
      const progressBarCompleted = claimedProduct?.querySelector('.js-progress-bar-completed')
      const claimedText = claimedProduct?.querySelector('.js-claimed-text')
      const productHandle = productCard.dataset.productHandle
      const actualPercentClaimed = Number(claimedProduct?.dataset.percentageClaimed || 0)

      if (!claimedProduct || !productHandle || !actualPercentClaimed) return

      let adjustedPercentClaimed = actualPercentClaimed
      const position = index + 1

      function isPrime(n) {
        if (n < 2) return false
        for (let i = 2; i <= Math.sqrt(n); i++) if (n % i === 0) return false
        return true
      }

      const handleOffset =
        [...productHandle].reduce((sum, ch) => sum + ch.charCodeAt(0), 0) % 8 - 2
      adjustedPercentClaimed += handleOffset

      if (position % 3 === 0) adjustedPercentClaimed -= 3
      if (isPrime(position)) adjustedPercentClaimed += 2

      if (adjustedPercentClaimed < 0) adjustedPercentClaimed = 0
      if (adjustedPercentClaimed > 95) adjustedPercentClaimed = 99

      if (claimedText) claimedText.innerText = adjustedPercentClaimed + '% claimed'
      if (progressBarCompleted) progressBarCompleted.style.width = adjustedPercentClaimed + '%'
    })
  }

  shouldScrollToProductInfoOnUpdate() {
    return Boolean(document.querySelector('.lp-long-sleeves-hero'))
  }

  onChange(event) {
    const target = event.target
    if (!target.matches('input[name="pdp-product-cards"]')) return
    const productUrl = this.getResolvedProductUrl(target)
    if (!productUrl) return
    const productInfo = document.querySelector('product-info')
    if (!productInfo) return
    const productCardsTitle = document.querySelector('.js-pdp-product-cards-title')
    if (productCardsTitle) {
      productCardsTitle.textContent = target.hasAttribute('data-flash-deal')
        ? 'Flash Deals'
        : target.dataset.productTitle
    }
    productInfo.style.opacity = 0.5
    productInfo.style.pointerEvents = 'none'
    const menuWithPdp = this.closest('menu-with-pdp')
    const isHomepageOptionsPoc =
      menuWithPdp?.getPdpView?.() === 'pdp-options-poc' && productInfo.dataset.optionsPoc
    const params = isHomepageOptionsPoc ? [] : ['view=pdp-liquid-quick-add']
    productInfo.changeFullSection(productUrl, false, params)
    document.addEventListener(
      'product-info-updated',
      () => {
        this.syncProductInfoClearanceState()
        productInfo.style.opacity = 1
        productInfo.style.pointerEvents = 'auto'
        // Scrolling back to the PDP is opt-in per landing page: the fabric tiles
        // in lp-long-sleeves-top sit above the PDP, so the swapped-in product
        // needs to be brought into view.
        if (this.shouldScrollToProductInfoOnUpdate()) {
          const offset = window.innerWidth < 768 ? 0 : 91
          window.scrollToElementV2('product-info', offset)
        }
      },
      { once: true },
    )
  }
}
customElements.define('product-cards', ProductCards)
